'use client';

import { useState } from 'react';
import { Alert } from '../Alert';
type CopyProps = {
  children?: React.ReactNode;
  className?: string;
  component?: React.ElementType;
  copiedMessage?: string;
  textToCopy: string;
};
export const Copy = ({
  children,
  className,
  component: Component = 'button',
  copiedMessage,
  textToCopy,
  ...restProps
}: CopyProps) => {
  const [showAlert, setShowAlert] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(textToCopy);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };
  return <>
      <Component aria-label='copy to clipboard' className={className} onClick={handleCopy} {...restProps} data-sentry-element="Component" data-sentry-source-file="Copy.tsx">
        {children}
      </Component>
      <Alert isOpen={showAlert} text={copiedMessage ? copiedMessage : 'link copied'} data-sentry-element="Alert" data-sentry-source-file="Copy.tsx" />
    </>;
};